module.exports = "<div id=\"image-container\">\n    <img (load)=\"setImageDimensions()\" [src]=\"media.preview\" id=\"image\">\n</div>\n"